module.exports = __webpack_public_path__ + "static/2.3_the_earliest_human_societies-761c565695741d9f2a706c8ef9db8544.pdf";